import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BrandPortfolioSellerNameCell = _resolveComponent("BrandPortfolioSellerNameCell");
  const _component_brand_portfolio_trending_cell = _resolveComponent("brand-portfolio-trending-cell");
  const _component_BrandPortfolioRevenueCell = _resolveComponent("BrandPortfolioRevenueCell");
  const _component_BrandPortfolioTacosCell = _resolveComponent("BrandPortfolioTacosCell");
  const _component_BrandPortfolioRoasCell = _resolveComponent("BrandPortfolioRoasCell");
  const _component_BrandPortfolioSpendCell = _resolveComponent("BrandPortfolioSpendCell");
  const _component_b_tr = _resolveComponent("b-tr");
  return _openBlock(), _createBlock(_component_b_tr, {
    class: "brand-portfolio-content"
  }, {
    default: _withCtx(() => [_createVNode(_component_BrandPortfolioSellerNameCell, {
      loading: $props.loading,
      portfolio: $props.portfolio,
      isLastSellerInWorkspace: $props.isLastSellerInWorkspace,
      onOnSellerNameClickHandler: $options.onSellerNameClickHandler,
      onOnWorkspaceAlertClickHandler: $options.onWorkspaceAlertClickHandler
    }, null, 8, ["loading", "portfolio", "isLastSellerInWorkspace", "onOnSellerNameClickHandler", "onOnWorkspaceAlertClickHandler"]), _createVNode(_component_brand_portfolio_trending_cell, {
      loading: $props.loading,
      portfolio: $props.portfolio,
      trendingType: "ytd",
      isLastSellerInWorkspace: $props.isLastSellerInWorkspace
    }, null, 8, ["loading", "portfolio", "isLastSellerInWorkspace"]), _createVNode(_component_brand_portfolio_trending_cell, {
      loading: $props.loading,
      portfolio: $props.portfolio,
      trendingType: "mtd",
      isLastSellerInWorkspace: $props.isLastSellerInWorkspace
    }, null, 8, ["loading", "portfolio", "isLastSellerInWorkspace"]), _createVNode(_component_brand_portfolio_trending_cell, {
      loading: $props.loading,
      portfolio: $props.portfolio,
      trendingType: "wtd",
      isLastSellerInWorkspace: $props.isLastSellerInWorkspace
    }, null, 8, ["loading", "portfolio", "isLastSellerInWorkspace"]), _createVNode(_component_BrandPortfolioRevenueCell, {
      loading: $props.loading,
      portfolio: $props.portfolio,
      periodLength: _ctx.periodLenght,
      period_data: $props.period_data,
      selected_period: $props.selected_period,
      isLastSellerInWorkspace: $props.isLastSellerInWorkspace
    }, null, 8, ["loading", "portfolio", "periodLength", "period_data", "selected_period", "isLastSellerInWorkspace"]), _createVNode(_component_BrandPortfolioTacosCell, {
      loading: $props.loading,
      portfolio: $props.portfolio,
      periodLength: _ctx.periodLenght,
      period_data: $props.period_data,
      selected_period: $props.selected_period,
      isLastSellerInWorkspace: $props.isLastSellerInWorkspace
    }, null, 8, ["loading", "portfolio", "periodLength", "period_data", "selected_period", "isLastSellerInWorkspace"]), _createVNode(_component_BrandPortfolioRoasCell, {
      loading: $props.loading,
      portfolio: $props.portfolio,
      periodLength: _ctx.periodLenght,
      period_data: $props.period_data,
      selected_period: $props.selected_period,
      isLastSellerInWorkspace: $props.isLastSellerInWorkspace
    }, null, 8, ["loading", "portfolio", "periodLength", "period_data", "selected_period", "isLastSellerInWorkspace"]), _createVNode(_component_BrandPortfolioSpendCell, {
      loading: $props.loading,
      portfolio: $props.portfolio,
      isLastSellerInWorkspace: $props.isLastSellerInWorkspace
    }, null, 8, ["loading", "portfolio", "isLastSellerInWorkspace"])]),
    _: 1
  });
}